import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale, LinearScale, PointElement, LineElement,
  BarElement, Title, Tooltip, Legend, Filler
);

const statsCards = [
  { label: 'Total Users',   value: '3,420',   change: '+12%',  up: true,  accent: '#4e73df' },
  { label: 'Revenue',       value: '$28,450',  change: '+8.2%', up: true,  accent: '#1cc88a' },
  { label: 'New Orders',    value: '142',      change: '+3.1%', up: true,  accent: '#f6c23e' },
  { label: 'Error Rate',    value: '0.42%',    change: '-0.1%', up: false, accent: '#e74a3b' },
];

const recentOrders = [
  { id: '#1042', user: 'Alice Johnson',  amount: '$340', status: 'Completed', date: 'Mar 28' },
  { id: '#1041', user: 'Bob Martinez',   amount: '$120', status: 'Pending',   date: 'Mar 27' },
  { id: '#1040', user: 'Carol White',    amount: '$899', status: 'Completed', date: 'Mar 27' },
  { id: '#1039', user: 'David Lee',      amount: '$55',  status: 'Failed',    date: 'Mar 26' },
  { id: '#1038', user: 'Eve Robinson',   amount: '$210', status: 'Completed', date: 'Mar 25' },
  { id: '#1037', user: 'Frank Kim',      amount: '$670', status: 'Pending',   date: 'Mar 24' },
];

const lineData = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  datasets: [
    {
      label: 'Revenue ($)',
      data: [12000, 19000, 15000, 22000, 18000, 25000, 28000, 24000, 30000, 27000, 32000, 28450],
      borderColor: '#4e73df',
      backgroundColor: 'rgba(78,115,223,0.08)',
      fill: true,
      tension: 0.4,
      pointRadius: 3,
    },
  ],
};

const barData = {
  labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  datasets: [
    {
      label: 'New Users',
      data: [65, 89, 74, 112, 98, 54, 43],
      backgroundColor: 'rgba(28,200,138,0.7)',
      borderRadius: 5,
    },
  ],
};

const chartOptions = {
  responsive: true,
  plugins: { legend: { position: 'top' } },
  scales: { y: { beginAtZero: true } },
};

const statusStyles = {
  Completed: { background: 'rgba(28,200,138,0.12)', color: '#1cc88a' },
  Pending:   { background: 'rgba(246,194,62,0.15)',  color: '#c9a227' },
  Failed:    { background: 'rgba(231,74,59,0.12)',   color: '#e74a3b' },
};

function StatusBadge({ status }) {
  const s = statusStyles[status] || {};
  return (
    <span className="badge-status" style={s}>{status}</span>
  );
}

function StatCard({ label, value, change, up, accent }) {
  return (
    <div className="card" style={{ borderLeft: `4px solid ${accent}` }}>
      <div className="card-body py-3">
        <div className="card-title">{label}</div>
        <div className="stat-value">{value}</div>
        <div className={`stat-change ${up ? 'up' : 'down'}`}>
          {up ? '▲' : '▼'} {change} this month
        </div>
      </div>
    </div>
  );
}

function Dashboard() {
  return (
    <div>
      {/* Stats */}
      <div className="stats-grid">
        {statsCards.map((card) => (
          <StatCard key={card.label} {...card} />
        ))}
      </div>

      {/* Charts row */}
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '20px', marginBottom: '28px' }}>
        <div className="card">
          <div className="card-body">
            <p className="section-title">Revenue Overview</p>
            <Line data={lineData} options={chartOptions} />
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <p className="section-title">New Users This Week</p>
            <Bar data={barData} options={chartOptions} />
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card">
        <div className="card-body">
          <p className="section-title">Recent Orders</p>
          <table className="dash-table">
            <thead>
              <tr>
                {['Order ID', 'Customer', 'Amount', 'Status', 'Date'].map((h) => (
                  <th key={h}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {recentOrders.map((order) => (
                <tr key={order.id}>
                  <td style={{ fontWeight: 600 }}>{order.id}</td>
                  <td>{order.user}</td>
                  <td style={{ fontWeight: 600 }}>{order.amount}</td>
                  <td><StatusBadge status={order.status} /></td>
                  <td style={{ color: 'var(--text-muted)' }}>{order.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
